export default __webpack_public_path__ + "static/media/annualLecture17.a27d07ad.png";